// Utilità di validazione italiane per anagrafica

export const norm = {
  cf: (v) => (v || "").replace(/\s+/g, "").toUpperCase(),
  vat: (v) => (v || "").replace(/\s+/g, ""),
  province: (v) => (v || "").replace(/\s+/g, "").toUpperCase().slice(0, 2),
};

const RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const RE_CAP = /^\d{5}$/;
const RE_VAT_IT = /^\d{11}$/;
const RE_CF_PERSON = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
const RE_CF_COMPANY = /^\d{11}$/;

export function validators(form, mode /* 'person' | 'company' */) {
  const errors = {};

  if (mode === "person") {
    if (!form.p_first_name?.trim()) errors.p_first_name = "Il nome è obbligatorio";
    if (!form.p_last_name?.trim()) errors.p_last_name = "Il cognome è obbligatorio";
  } else {
    if (!form.c_business_name?.trim()) errors.c_business_name = "La denominazione è obbligatoria";
  }

  if (form.email && !RE_EMAIL.test(form.email))
    errors.email = "Email non valida";
  if (form.pec && !RE_EMAIL.test(form.pec))
    errors.pec = "PEC non valida (formato email)";

  const cf = norm.cf(form.fiscal_code);
  if (cf) {
    const okPerson = RE_CF_PERSON.test(cf);
    const okCompany = RE_CF_COMPANY.test(cf);
    if (mode === "person" && !okPerson && !okCompany) errors.fiscal_code = "Codice fiscale non valido (16 caratteri)";
    if (mode === "company" && !okCompany && !okPerson) errors.fiscal_code = "Codice fiscale impresa non valido (11 cifre)";
  }
  const vat = norm.vat(form.vat_number);
  if (vat && !RE_VAT_IT.test(vat)) errors.vat_number = "Partita IVA non valida (11 cifre)";

  if (form.p_birth_date) {
    const d = new Date(form.p_birth_date);
    if (isNaN(d.getTime())) errors.p_birth_date = "Data non valida";
    else if (d > new Date()) errors.p_birth_date = "La data non può essere futura";
  }
  if (form.c_incorporation_date && new Date(form.c_incorporation_date) > new Date())
    errors.c_incorporation_date = "La data non può essere futura";

  if (form.c_employees_count && (isNaN(+form.c_employees_count) || +form.c_employees_count < 0))
    errors.c_employees_count = "Numero dipendenti non valido";
  if (form.c_revenue_last_year && isNaN(parseFloat(form.c_revenue_last_year)))
    errors.c_revenue_last_year = "Fatturato non valido";
  if (form.c_share_capital && isNaN(parseFloat(form.c_share_capital)))
    errors.c_share_capital = "Capitale sociale non valido";

  return errors;
}

export function validateAddress(addr) {
  const e = {};
  if (addr.zip && !RE_CAP.test(addr.zip)) e.zip = "CAP non valido (5 cifre)";
  return e;
}

export function formatDate(v) {
  if (!v) return "—";
  try { return new Date(v).toLocaleDateString("it-IT"); } catch { return v; }
}
